var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-dialog" }, [
    _c("div", { staticClass: "modal_content" }, [
      _c("div", { staticClass: "modal_header" }, [
        _c("h5", [
          _vm._v(
            "\n        " + _vm._s(_vm.$t("sdl.common.label.help")) + "\n      "
          )
        ]),
        _vm._v(" "),
        _c("button", {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal_body" }, [
        _c("div", { staticClass: "form_wrap" }, [
          _c("div", { staticClass: "fx_form_wrap" }, [
            _c("div", { staticClass: "form_row" }, [
              _c("div", { staticClass: "form_item" }, [
                _c("p", { staticClass: "pre" }, [_vm._v(_vm._s(_vm.title))]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "agree_box" }, [
                  _c("p", { staticClass: "pre" }, [_vm._v(_vm._s(_vm.content))])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal_footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-secondary",
            attrs: { type: "button", "data-dismiss": "modal" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("sdl.common.label.close")) +
                "\n      "
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12538e02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12538e02","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/etc/help/popup/HelpPopup.vue
// module id = null
// module chunks = 